import { useDispatch as useReduxDispatch } from 'react-redux';

import { Dispatch } from 'stores/ReduxStore';

const useDispatch: () => Dispatch = useReduxDispatch;

export default useDispatch;
